<template>
  <div v-if="!!uploadUrl">
    <v-card outlined rounded="lg">
      <v-card-title> Subir fotos do celular com QR code </v-card-title>
      <v-container>
        <v-row>
          <v-col>
            <qrcode-vue :value="uploadUrl" level="H" :size="196" :foreground="disabled ? '#b3b3b3' : '#000000'" />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
  <v-sheet v-else>
    <h1>
      Este atendimento foi gerado sem a possibilidade de utilizar QR Code.
      <br />
      Se você acredita que isto é um erro, entre em contato com o Suporte.
    </h1>
  </v-sheet>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import QrcodeVue from 'qrcode.vue'

const { mapGetters: newAttendanceFormGetters } = createNamespacedHelpers('newAttendanceForm')

export default {
  components: {
    QrcodeVue,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...newAttendanceFormGetters(['attendance', 'extraAnswers']),
    uuid() {
      return this.attendance.patient.uuid
    },
    uploadUuid() {
      return this.attendance?.uploadPhotoUuid
    },
    attendanceId() {
      return parseInt(this.attendance.id)
    },
    uploadUrl() {
      if (!this.uploadUuid) {
        return null
      }
      return `${window.location.origin}/upload-attendance-photo?u=${this.uuid}&a=${this.attendanceId}`
    },
  },
}
</script>

<style scoped>
.border-gray {
  border: 1px solid #e6e6e6;
}
</style>
